<a
  class="sidenav-item__link"
  [ngClass]="{
    'sidenav-item__link--client': isClientSidenavItem,
    'sidenav-item__link--parent': hasSubItems,
  }"
  [ngClass]="'sidenav-item__link--' + itemLevel"
  (click)="sideNavItemClicked()"
  [routerLinkActiveOptions]="itemRouterLinkActiveOptions"
  [routerLink]="itemRouterLink"
  routerLinkActive="sidenav-item__link--active"
  [attr.data-e2e]="e2e"
>
  <app-svg-icon
    *ngIf="icon"
    class="sidenav-item__icon"
    [icon]="icon"
    fill=""
    size="medium"
  ></app-svg-icon>

  <span class="sidenav-item__title" ellipsisTitle>
    {{ itemTitle }}
  </span>
</a>

<!-- You can nest up to three times sidenav-items - More than that shouldn't be allowed -->
<ng-content></ng-content>
